module.exports = __webpack_public_path__ + "img/dataRequest.6f333359.png";